import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-stickernummer',
  templateUrl: './stickernummer.component.html',
  styleUrls: ['./stickernummer.component.scss'],
})
export class StickernummerComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private letzteVisumStickernummerSub: Subscription;
  private schengenlaendercodeSub: Subscription;
  schengenlaendercodeListItems: ValueListItem[];

  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl,
              @Inject(APP_CONFIG) public appConfig: AppConfig
  ) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      letzteVisumStickernummer: [null, validationService.getValidators('reisedaten.letzteVisumStickernummer')],
      letzteVisumStickernummerSchengenLaendercode: [null, validationService.getValidators('reisedaten.letzteVisumStickernummer.schengenLaendercode')],
      letzteVisumStickernummerNummer: [null, validationService.getValidators('reisedaten.letzteVisumStickernummer.nummer')],
    }));
  }

  ngOnInit() {
    super.ngOnInit();

    this.schengenlaendercodeSub = this.valueListsService.getValueListItems('schengenlaendercode')
    .subscribe((listItems: ValueListItem[]) => this.schengenlaendercodeListItems = listItems);

    this.letzteVisumStickernummerSub = this.form.controls.letzteVisumStickernummer.valueChanges.subscribe(value => {
      if (this.form.value.letzteVisumStickernummer !== value) {
        this.enableOrDisableLetzteVisumStickernummer(value === true);
      }
    });

  }

  ngOnDestroy() {
    this.schengenlaendercodeSub.unsubscribe();
    this.letzteVisumStickernummerSub.unsubscribe();
  }

  onValidatorUpdate() {
    super.onValidatorUpdate();
    this.enableOrDisableLetzteVisumStickernummer(this.form.controls.letzteVisumStickernummer.value === true);
  }

  private enableOrDisableLetzteVisumStickernummer(letzteVisumStickernummer: boolean) {
    if (letzteVisumStickernummer) {
      this.form.controls.letzteVisumStickernummerSchengenLaendercode.enable();
      this.form.controls.letzteVisumStickernummerNummer.enable();
    } else {
      this.form.controls.letzteVisumStickernummerSchengenLaendercode.disable();
      this.form.controls.letzteVisumStickernummerNummer.disable();
    }
  }
}
